require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-lettenhofpark.json") })
        }
      }, "path---projecten-lettenhofpark");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-lettenhofpark!./.cache/json/projecten-lettenhofpark.json
// module id = 428
// module chunks = 231608221292675